import React from "react";
import Meta from "./Meta";
import Interests from "./Interests";

const Details = ({ user }) => {
  const formattedDob = new Date(user?.dob)
    .toISOString()
    .split("T")[0]
    .replace(/-/g, "/");

  return (
    <div className="p-4 space-y-4">
      {/* Gender, Interested In, Interaction */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <div className="space-y-1">
          <label className="text-white capitalize">Gender</label>
          <input
            type="text"
            value={
              user?.gender ? (user.gender === "F" ? "Female" : "Male") : ""
            }
            readOnly
            className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
          />
        </div>
      </div>
      {/* First Name */}
      <div className="space-y-1">
        <label className="text-white capitalize">First Name</label>
        <input
          type="text"
          value={user?.first_name ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Last Name */}
      <div className="space-y-1">
        <label className="text-white capitalize">Last Name</label>
        <input
          type="text"
          value={user?.last_name ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Birthday */}
      <div className="space-y-1">
        <label className="text-white capitalize">Birthday</label>
        <input
          type="text"
          value={formattedDob}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Level of Education */}
      <div className="space-y-1">
        <label className="text-white capitalize">Level of Education</label>
        <input
          type="text"
          value={user?.education ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Name of Institution */}
      <div className="space-y-1">
        <label className="text-white capitalize">Name of Institution</label>
        <input
          type="text"
          value={user?.institute ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Occupation */}
      <div className="space-y-1">
        <label className="text-white capitalize">Occupation</label>
        <input
          type="text"
          value={user?.occupation ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* Email */}
      <div className="space-y-1">
        <label className="text-white capitalize">Email</label>
        <input
          type="text"
          value={user?.email ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* LinkedIn */}
      <div className="space-y-1">
        <label className="text-white capitalize">LinkedIn</label>
        <input
          type="text"
          value={user?.linkedin ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      {/* City */}
      <div className="space-y-1">
        <label className="text-white capitalize">City</label>
        <input
          type="text"
          value={user?.city ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
      <Meta user={user} />

      <Interests user={user} />

      {/* Bio */}
      <div className="space-y-1">
        <label className="text-white capitalize">Bio</label>
        <textarea
          value={user?.bio ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>

      {/* NIN */}
      <div className="space-y-1">
        <label className="text-white capitalize">NIN</label>
        <input
          type="text"
          value={user?.nin ?? ""}
          readOnly
          className="bg-gray-700 outline-none text-white shadow-sm w-full rounded-lg p-2"
        />
      </div>
    </div>
  );
};

export default Details;
